export enum AuditTimeTypeEnum {
    BeginningOfDay,
    EndOfDay
  }
  